// @flow
import { getLogger } from "@cld/upload-widget";

type SendOptions = { // todo: add logic to support request/response between two clients of postmessage
    target?: ?string,
    requestId?: ?string,
    dontSerialize?: ?boolean,
};

const logger = getLogger();

const getData = (dataStr: string, origin: string) => {
	let data = null;

	try {
		data = typeof (dataStr) === "string" ? JSON.parse(dataStr) : dataStr;
	} catch (err) {
		logger.warn(`[postmessage]: failed to parse data from ${origin}`, dataStr, err.message);
	}

	return data;
};

const throwIfNoTarget = (target) => {
	if (!target || !target.length) {
		throw new Error("PostMessage - target not set!");
	}
};

type optionsType = { target: string | string[], types: { [string]: Function } };

export default (other: any, options: optionsType) => {
	let replyTarget;
	const sendTarget = Array.isArray(options.target) ? options.target : [options.target];

	const { types } = options;

	const handleMessage = (e: Object) => {
		if (~sendTarget.indexOf(e.origin)) {
			replyTarget = e.origin;

			const data = getData(e.data, e.origin);

			if (data) {
				if (data.type && types[data.type]) {
					logger.log(`[postmessage]: found matching handler for '${data.type}' event from: ${e.origin}`);
					types[data.type](data.data, data.type, e, options); // call the 'event handler' provided
				}
			}
		}
	};

	const close = () => self.removeEventListener("message", handleMessage);

	const send = (data: Object, sendOptions: SendOptions = {}) => { // target: ?string = null) => {
		const target = sendOptions.target || sendTarget[0] || replyTarget;

		throwIfNoTarget(target);

		try {
			logger.log(`[postmessage]: posting message to: ${target}`);
			other.postMessage(JSON.stringify(data), target);
		} catch (err) {
			logger.error(`[postmessage]: failed to post message to target: ${target}`, err);
		}
	};

	throwIfNoTarget(sendTarget);

	self.addEventListener("message", handleMessage, false);

	return {
		send,
		close,
	};
};
